import { Dispatch } from "redux";
import { AxnRelyingParty, AxnCompany } from "@idw-types/data/reference-data/axn";
import { createRelyingPartyRequest } from "@requests/axnadmin-core";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { formatRelyingParty } from "@formatters/relying-parties/relying-party-formatter";
import { addRelyingParty } from "@redux/actions/relying-parties-actions";

export const createRelyingPartyReduxRequest = (dispatch: Dispatch) => async (
    companyID: string,
    name: string,
    companies: Array<AxnCompany>
): Promise<AxnRelyingParty> => {
    const { data, error, body } = await createRelyingPartyRequest(companyID, name);
    if (data?.response) {
        const formattedRelyingParty = formatRelyingParty(data.response, companies);
        dispatch(addRelyingParty({
            ...formattedRelyingParty,
            permissions: {
                canArchive: true,
                canDelete: true,
                canModify: true,
                canRestore: true,
                canView: true
            }
        }));
        displaySuccessModal(
            dispatch,
            resources.requests.createRelyingParty.success.title,
            resources.requests.createRelyingParty.success.message
        );
        return data.response;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.createRelyingParty.error.title,
            resources.requests.createRelyingParty.error.message,
            null,
            null,
            body
        );   
    }

    return null;
};